export function animateModalContainer(card, modalMask, modalContainer = undefined) {
  modalContainer = !modalContainer ? modalMask.querySelector('.schedule-modal-container') : modalContainer;

  let  scheduleModal = modalContainer.querySelector('.schedule-modal'),
    maxWidth = document.documentElement.clientWidth,
    maxHeight = document.documentElement.clientHeight,
    left = card.getBoundingClientRect().left,
    top = card.getBoundingClientRect().top;

  top = top + scheduleModal.clientHeight > maxHeight ? top - scheduleModal.clientHeight + card.clientHeight / 2 : top - (scheduleModal.clientHeight / 2);
  top = top < 0 ? 10 : top; // avoid across border
  if (left + card.clientWidth + scheduleModal.clientWidth + 50 > maxWidth) {
    left -= scheduleModal.clientWidth + 30;
    modalContainer.style.transform = 'translateX(20px)';
  } else {
    left += card.clientWidth + 30;
    modalContainer.style.transform = 'translateX(-20px)';
  }

  scheduleModal.style.left = `${left < 0 ? 10 : left}px`;
  scheduleModal.style.top = `${top}px`;

  modalMask.classList.add('show');
}

export function closeScheduleModal(ev) {
  return new Promise((resolve, reject) => {
    let target = ev.target, _self = this;

    if (!target.classList.contains('schedule-modal-container') && !target.classList.contains('close-action'))
      return reject();

    let modalMask = target.closest('.schedule-modal-mask');

    requestAnimationFrame(() => {
      modalMask.querySelector('.schedule-modal-container').style.transform = 'translateX(0px)';
      setTimeout(() => {
        modalMask.classList.remove('show');
        document.querySelector('.schedule-mask')?.click(); // close possible opened card
        resolve.bind(_self)();
      }, 200)
    });
  });
}
